module.exports = __webpack_public_path__ + "img/title.0de145a5.svg";